import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { IPackageType, PackageType, PackageTypes } from '../../package-type';
import { BillingType } from '../../billing-type';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { BillingUnitModuleModel } from '../billing-unit-module.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiToggleSwitchLabelAlign } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';

interface IPackageTypeListData {
    Id: PackageType;
    Name: string;
}

@Component({
    selector: 'fi-billing-unit-edit',
    templateUrl: './billing-unit-edit.component.html',
    styleUrls: ['./billing-unit-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-unit-edit' },
    standalone: false,
})
export class BillingUnitEditComponent implements OnInit {
    @Input() unitModule: BillingUnitModuleModel;
    FiToggleSwitchLabelAlign = FiToggleSwitchLabelAlign;
    packageTypeListData = new DropdownSettingsModelV2<IPackageTypeListData>({
        orderBy: 'Id',
    });
    editTabs: EditTabsModel;

    constructor(
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
    ) {}

    ngOnInit() {
        this.setPackageTypeListData();
        this.saveChangesWarningService.start(() => this.unitModule);
        this.setPageHeaderData();
    }

    private setPackageTypeListData() {
        const packageTypeNames: IPackageTypeListData[] = [];
        PackageTypes.forEach((item: IPackageType) => {
            if (this.unitModule.BillingType === BillingType.Local || item.Id >= this.unitModule.CentralPackageType)
                packageTypeNames.push({ Id: item.Id, Name: this.appTextService.get(item.TextId) });
        });

        this.packageTypeListData.setDataSet(packageTypeNames);
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(this.objectTitleService.getEditTitle(this.unitModule.ModuleTypeName));
        this.editTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    save() {
        this.fiLoadingService.trackPromise(this.billingService.SaveUnitBillingModule(this.unitModule)).then(() => {
            this.saveChangesWarningService.stop();
            this.stateService.go(FiStateNames.Billing.Unit.List);
        });
    }
}
